import { useTranslation } from 'react-i18next'

import { getMatchTypeOptions } from '@/common/components/MatchTypeEditor/helpers'
import MatchTypeEditor from '@/common/components/MatchTypeEditor/MatchTypeEditor'

import { getEmptyAmountValue, isAmountFilterValid } from '../helpers'
import { amountFieldConfig } from './constants'
import { buildAmountUpdate, getValueForMatchType } from './helpers'

const AmountFilter = ({ filterConfig, value, onChangeValue }) => {
  const { t } = useTranslation()

  const matchType = value[filterConfig.matchTypeName]
  const matchTypeOptions = getMatchTypeOptions(amountFieldConfig, t)
  const hasError = Boolean(matchType) && !isAmountFilterValid(value, filterConfig)

  const handleChangeMatchType = newMatchType => {
    onChangeValue({ ...getEmptyAmountValue(filterConfig), [filterConfig.matchTypeName]: newMatchType })
  }

  const handleChangeAmount = newValue => {
    onChangeValue(buildAmountUpdate(filterConfig, matchType, newValue))
  }

  return (
    <MatchTypeEditor
      matchType={matchType}
      field={filterConfig.field}
      matchTypeOptions={matchTypeOptions}
      onChangeMatchType={handleChangeMatchType}
      value={getValueForMatchType(value, filterConfig, matchType)}
      onChange={handleChangeAmount}
      hasError={hasError}
    />
  )
}

export default AmountFilter
